import { createSlice, createSelector } from "@reduxjs/toolkit";
// import { format } from "date-fns";
import moment from "moment";

const appointmentSlice = createSlice({
  name: "appointment",
  initialState: {
    appointments: [], // Stores all appointments
    showCreateAppointmentModal: false,
    showRescheduleAppointmentModal: false,
  },
  reducers: {
    setAppointments: (state, action) => {
      state.appointments = action.payload;
    },
    setOpenCreateAppointmentModal: (state, action) => {
      state.showCreateAppointmentModal = true;
    },
    setCloseCreateAppointmentModal: (state, action) => {
      state.showCreateAppointmentModal = false;
    },
    setOpenRescheduleAppointmentModal: (state, action) => {
      state.showRescheduleAppointmentModal = true;
    },
    setCloseRescheduleAppointmentModal: (state, action) => {
      state.showRescheduleAppointmentModal = false;
    },
  },
});

export const {
  setAppointments,
  setOpenCreateAppointmentModal,
  setCloseCreateAppointmentModal,
  setCloseRescheduleAppointmentModal,
  setOpenRescheduleAppointmentModal,
} = appointmentSlice.actions;
export default appointmentSlice.reducer;

// 🔹 Select all appointments
export const selectAllAppointments = (state) => state.appointment.appointments;

export const selectTodaysAppointments = createSelector(
  [selectAllAppointments],
  (appointments) => {
    const startOfToday = moment().startOf("day");
    const endOfToday = moment().endOf("day");

    return appointments.filter((appt) => {
      const localTime = moment.utc(appt.appointment_time).local();

      return (
        localTime.isBetween(startOfToday, endOfToday, null, "[]") &&
        appt.status !== "cancelled" &&
        appt.status !== "requested"
      );
    });
  }
);

export const selectTodaysPendingAppointments = createSelector(
  [selectAllAppointments],
  (appointments) => {
    const startOfToday = moment().startOf("day");
    const endOfToday = moment().endOf("day");

    return appointments.filter((appt) => {
      const localTime = moment.utc(appt.appointment_time).local();

      return (
        localTime.isBetween(startOfToday, endOfToday, null, "[]") &&
        appt.status === "requested"
      );
    });
  }
);

// 🔹 Select appointments for a specific location
export const selectAppointmentsByLocation = (locationId) =>
  createSelector([selectAllAppointments], (appointments) =>
    appointments.filter((appt) => appt.locationId === locationId)
  );

export const selectAppointmentById = (appointmentId) =>
  createSelector([selectAllAppointments], (appointments) =>
    appointments.find((appt) => appt.id === appointmentId)
  );
